import { render, staticRenderFns } from "./AiInstructionalBuilderModal.vue?vue&type=template&id=53151032&scoped=true"
import script from "./AiInstructionalBuilderModal.vue?vue&type=script&lang=js"
export * from "./AiInstructionalBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./AiInstructionalBuilderModal.vue?vue&type=style&index=0&id=53151032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53151032",
  null
  
)

export default component.exports